import DialogInfo from '~/components/dialog/info/DialogInfo.vue';

export const useFormMaxChoices = (field: FormField, model) => {
  const dialog = useDialogStore();

  const nbMax = computed(() => {
    if (field.multiple) return getNbMaxFromValidation(field.validation);
    return 1;
  });

  const isMaxChoicesReached = computed(() => {
    return nbMax.value === -1 ? false : model.value.length >= nbMax.value;
  });

  const openDialogMaxChoices = () => {
    if (dialog.isOpened) return;
    const description =
      nbMax.value === 1
        ? `Vous ne pouvez pas sélectionner plus de 1 option`
        : `Vous ne pouvez pas sélectionner plus de ${nbMax.value} options`;
    dialog.open(DialogInfo, {
      level: DialogLevel.Info,
      title: field.label || '',
      label: description,
      onConfirm: () => dialog.close(),
    });
  };

  return { nbMax, isMaxChoicesReached, openDialogMaxChoices };
};
